import PageMeta from '@/components/feature/PageMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import DailyRevealSection from './components/DailyRevealSection';
import HotArticlesSection from './components/HotArticlesSection';
import AppDownloadSection from './components/AppDownloadSection';
import TimelineSection from './components/TimelineSection';
import StatsSection from './components/StatsSection';

function HomePage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'http://91flj.cn/#organization',
        name: '吃瓜爆料网',
        url: 'http://91flj.cn/',
        description: '吃瓜爆料网一站导航吃瓜爆料网官网、吃瓜爆料网app下载与吃瓜爆料网最新地址，每日首发网红塌房反差视频、博主爆料聊天记录，黑料大瓜实时追踪不停更。',
        sameAs: ['http://91flj.cn/'],
      },
      {
        '@type': 'WebSite',
        '@id': 'http://91flj.cn/#website',
        name: '吃瓜爆料网',
        url: 'http://91flj.cn/',
        inLanguage: 'zh-CN',
        publisher: { '@id': 'http://91flj.cn/#organization' },
      },
      {
        '@type': 'WebPage',
        '@id': 'http://91flj.cn/#webpage',
        name: '吃瓜爆料网 - 首页',
        url: 'http://91flj.cn/',
        isPartOf: { '@id': 'http://91flj.cn/#website' },
        about: { '@id': 'http://91flj.cn/#organization' },
        primaryImageOfPage: {
          '@type': 'ImageObject',
          url: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20moody%20background%20with%20warm%20amber%20and%20deep%20crimson%20gradient%20lighting%2C%20abstract%20geometric%20patterns%20subtle%20in%20background%2C%20mysterious%20cinematic%20atmosphere%2C%20red%20carpet%20texture%20hints%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20professional%20composition%2C%20dark%20elegant%20aesthetic&width=1600&height=900&seq=hero-bg-2026-x1&orientation=landscape',
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '吃瓜爆料网是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '吃瓜爆料网是一个专注于网红塌房、黑料大瓜、反差视频、博主聊天记录曝光的娱乐资讯平台，每日首发更新最新爆料内容。',
            },
          },
          {
            '@type': 'Question',
            name: '如何下载吃瓜爆料网APP？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '访问吃瓜爆料网官网或吃瓜爆料网最新地址，在首页即可找到吃瓜爆料网APP下载入口，支持安卓和iOS双平台。',
            },
          },
          {
            '@type': 'Question',
            name: '吃瓜爆料网更新频率如何？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '吃瓜爆料网每日首发更新，网红塌房、黑料大瓜实时追踪不停更，确保您第一时间获取最新爆料资讯。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <PageMeta
        title="吃瓜爆料网 - 网红黑料大瓜每日首发更新 | 吃瓜爆料网官网"
        description="吃瓜爆料网一站导航吃瓜爆料网官网、吃瓜爆料网app下载与吃瓜爆料网最新地址，每日首发网红塌房反差视频、博主爆料聊天记录，黑料大瓜实时追踪不停更。吃瓜爆料网，网红塌房，黑料大瓜，每日爆料。"
        keywords="吃瓜爆料网, 吃瓜爆料网app, 吃瓜爆料网下载, 吃瓜爆料网官网, 吃瓜爆料网最新地址, 网红塌房, 黑料大瓜, 每日爆料"
        canonicalUrl="http://91flj.cn/"
        ogImage="https://readdy.ai/api/search-image?query=Dramatic%20dark%20moody%20background%20with%20warm%20amber%20and%20deep%20crimson%20gradient%20lighting%20abstract%20geometric%20patterns%20subtle%20in%20background%20mysterious%20cinematic%20atmosphere%20editorial%20photography%20style%20high%20contrast%20professional%20composition&width=1200&height=630&seq=og-homepage&orientation=landscape"
        jsonLd={jsonLd}
      />

      <main>
        <Navbar />
        <HeroSection />
        <HotArticlesSection />
        <DailyRevealSection />
        <TimelineSection />
        <StatsSection />
        <AppDownloadSection />
        <Footer />
      </main>
    </>
  );
}

export default HomePage;